import MobileAppSplash from './MobileAppSplash'

export default MobileAppSplash
